var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66797 13.2869L6.86609 9.09558L16.913 20.9461L13.6414 21.2625L5.66797 13.2869Z",
    fill: "#BF8400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.84375 1.23611V26.1563H25.7639C25.9095 26.1563 25.9812 25.9812 25.8778 25.8778L1.12219 1.1222C1.01883 1.01884 0.84375 1.09056 0.84375 1.23611ZM6.03703 12.6774L14.7635 21.2625H6.03703V12.6774Z",
    fill: "#EAA700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66789 21.4755L0.84375 26.1562H25.7639C25.9095 26.1562 25.9812 25.9812 25.8778 25.8778L24.7598 24.7598L5.66789 21.4755Z",
    fill: "#BF8400"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50195 1.85833V25.3483C1.50195 25.4306 1.56734 25.496 1.64961 25.496H25.1396C25.2704 25.496 25.3379 25.3357 25.2451 25.2429L1.75508 1.75497C1.66227 1.66216 1.50195 1.72755 1.50195 1.85833ZM6.09406 12.9326L14.0675 20.906H6.09406V12.9326Z",
    fill: "url(#paint0_linear_12_582)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11987 4.18078C2.0144 4.28624 2.0144 4.45921 2.11987 4.56468L2.33292 4.77773C2.43839 4.8832 2.61136 4.8832 2.71683 4.77773L3.74831 3.74625L3.15136 3.14929L2.11987 4.18078Z",
    fill: "#795548"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15146 3.15143L2.65576 3.64713L3.25061 4.24198L3.74631 3.74627L3.15146 3.15143Z",
    fill: "url(#paint1_linear_12_582)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08569 8.14641C5.98022 8.25188 5.98022 8.42485 6.08569 8.53032L6.29874 8.74337C6.40421 8.84884 6.57718 8.84884 6.68265 8.74337L7.71413 7.71188L7.11718 7.11493L6.08569 8.14641Z",
    fill: "#795548"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11704 7.11493L6.62134 7.61063L7.21618 8.20759L7.71189 7.71188L7.11704 7.11493Z",
    fill: "url(#paint2_linear_12_582)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.051 12.1121C9.94556 12.2175 9.94556 12.3905 10.051 12.496L10.2641 12.709C10.3695 12.8145 10.5425 12.8145 10.648 12.709L11.6795 11.6775L11.0825 11.0806L10.051 12.1121Z",
    fill: "#795548"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0828 11.0806L10.585 11.5763L11.1819 12.1732L11.6776 11.6775L11.0828 11.0806Z",
    fill: "url(#paint3_linear_12_582)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0168 16.0776C13.9114 16.1831 13.9114 16.3561 14.0168 16.4615L14.2299 16.6746C14.3354 16.78 14.5083 16.78 14.6138 16.6746L15.6453 15.6431L15.0483 15.0461L14.0168 16.0776Z",
    fill: "#795548"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.046 15.0461L14.5503 15.5418L15.1472 16.1388L15.6429 15.6431L15.046 15.0461Z",
    fill: "url(#paint4_linear_12_582)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9824 20.0433C17.877 20.1488 17.877 20.3218 17.9824 20.4272L18.1955 20.6403C18.3009 20.7457 18.4739 20.7457 18.5794 20.6403L19.6109 19.6088L19.0139 19.0118L17.9824 20.0433Z",
    fill: "#795548"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0118 19.0118L18.5161 19.5075L19.1131 20.1045L19.6088 19.6088L19.0118 19.0118Z",
    fill: "url(#paint5_linear_12_582)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.948 24.0089C21.8425 24.1144 21.8425 24.2873 21.948 24.3928L22.161 24.6059C22.2665 24.7113 22.4395 24.7113 22.5449 24.6059L23.5764 23.5744L22.9795 22.9774L21.948 24.0089Z",
    fill: "#795548"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9774 22.9774L22.4817 23.4731L23.0786 24.0701L23.5743 23.5744L22.9774 22.9774Z",
    fill: "url(#paint6_linear_12_582)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18018 10.8611C7.07471 10.9666 7.07471 11.1396 7.18018 11.245L7.54932 11.6142C7.65479 11.7197 7.82775 11.7197 7.93322 11.6142L9.66924 9.87817L8.91619 9.12512L7.18018 10.8611Z",
    fill: "#795548"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02174 9.01965L8.52393 9.51536L9.27697 10.2684L9.77268 9.7727L9.02174 9.01965Z",
    fill: "url(#paint7_linear_12_582)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.146 14.8268C11.0405 14.9322 11.0405 15.1052 11.146 15.2107L11.5151 15.5798C11.6206 15.6853 11.7936 15.6853 11.899 15.5798L13.6351 13.8438L12.882 13.0908L11.146 14.8268Z",
    fill: "#795548"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9852 12.9853L12.4895 13.481L13.2425 14.234L13.7383 13.7383L12.9852 12.9853Z",
    fill: "url(#paint8_linear_12_582)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2146 6.89556C3.10913 7.00103 3.10913 7.174 3.2146 7.27947L3.58374 7.64861C3.68921 7.75408 3.86218 7.75408 3.96765 7.64861L5.70366 5.91259L4.95062 5.15955L3.2146 6.89556Z",
    fill: "#795548"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05625 5.05408L4.56055 5.54978L5.31148 6.30283L5.80719 5.80712L5.05625 5.05408Z",
    fill: "url(#paint9_linear_12_582)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1116 18.7925C15.0061 18.8979 15.0061 19.0709 15.1116 19.1764L15.4807 19.5455C15.5862 19.651 15.7592 19.651 15.8646 19.5455L17.6006 17.8095L16.8476 17.0565L15.1116 18.7925Z",
    fill: "#795548"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.951 16.951L16.4553 17.4467L17.2084 18.1997L17.7041 17.704L16.951 16.951Z",
    fill: "url(#paint10_linear_12_582)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0771 22.758C18.9717 22.8635 18.9717 23.0365 19.0771 23.142L19.4463 23.5111C19.5518 23.6166 19.7247 23.6166 19.8302 23.5111L21.5662 21.7751L20.8132 21.022L19.0771 22.758Z",
    fill: "#795548"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9166 20.9166L20.4209 21.4123L21.1739 22.1653L21.6696 21.6696L20.9166 20.9166Z",
    fill: "url(#paint11_linear_12_582)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_582",
    x1: 6.47122,
    y1: 20.5288,
    x2: 17.1468,
    y2: 9.85329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#FDD835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#F9A825"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_582",
    x1: 2.94875,
    y1: 3.94898,
    x2: 3.27718,
    y2: 3.62034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D4037",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12_582",
    x1: 6.91412,
    y1: 7.91438,
    x2: 7.24276,
    y2: 7.58595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D4037",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12_582",
    x1: 10.8799,
    y1: 11.88,
    x2: 11.2083,
    y2: 11.5514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D4037",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12_582",
    x1: 14.845,
    y1: 15.8454,
    x2: 15.1734,
    y2: 15.5167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D4037",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12_582",
    x1: 18.8106,
    y1: 19.8109,
    x2: 19.1392,
    y2: 19.4824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D4037",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12_582",
    x1: 22.7762,
    y1: 23.7764,
    x2: 23.1046,
    y2: 23.4478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D4037",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12_582",
    x1: 8.93842,
    y1: 9.85539,
    x2: 9.20736,
    y2: 9.58644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D4037",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12_582",
    x1: 12.9038,
    y1: 13.8208,
    x2: 13.1729,
    y2: 13.5519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D4037",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12_582",
    x1: 4.97293,
    y1: 5.89002,
    x2: 5.24209,
    y2: 5.62087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D4037",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12_582",
    x1: 16.8696,
    y1: 17.7865,
    x2: 17.1385,
    y2: 17.5174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D4037",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12_582",
    x1: 20.835,
    y1: 21.7519,
    x2: 21.1039,
    y2: 21.4829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D4037",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4037"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuler);
export default __webpack_public_path__ + "static/media/ruler.258427e8cda1a7af092c2735a470e2cc.svg";
export { ForwardRef as ReactComponent };